/* ------------------------------------------------------------------
   Dario GLP-1 — page interactions + assessment funnel engine
   Loaded once per page. Safe to include from several sections: the
   guard below makes every run after the first a no-op.
   ------------------------------------------------------------------ */
(function () {
  'use strict';
  if (window.__dglpBooted) return;
  window.__dglpBooted = true;

  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var esc = function (s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  };

  /* ================================================================
     1. TRACKING
     One dispatcher, four destinations. Nothing here ever carries a
     condition, medication or answer text unless the merchant has
     explicitly switched that on in the theme editor.
     ================================================================ */
  var DGLP = window.DarioGLP1 = window.DarioGLP1 || {};
  var CFG = window.DARIO_GLP1_TRACK || {};
  var SID = (function () {
    try {
      var k = 'dglp_sid', v = sessionStorage.getItem(k);
      if (!v) {
        v = 'dglp_' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
        sessionStorage.setItem(k, v);
      }
      return v;
    } catch (e) { return 'dglp_' + Date.now().toString(36); }
  })();

  var seq = 0;
  function eventId(name) {
    seq += 1;
    return SID + '.' + name + '.' + seq;
  }

  DGLP.track = function (name, params) {
    var p = params || {};
    var payload = {
      funnel: CFG.funnel || 'glp1_assessment',
      session_id: SID,
      event_id: eventId(name)
    };
    for (var k in p) { if (Object.prototype.hasOwnProperty.call(p, k)) payload[k] = p[k]; }

    /* GTM / GA4 via dataLayer */
    if (CFG.dataLayer !== false) {
      window.dataLayer = window.dataLayer || [];
      var dl = { event: name };
      for (var a in payload) { if (Object.prototype.hasOwnProperty.call(payload, a)) dl[a] = payload[a]; }
      window.dataLayer.push(dl);
    }

    /* Shopify Web Pixels — a custom pixel subscribes to these */
    if (CFG.shopifyAnalytics !== false) {
      try {
        if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
          window.Shopify.analytics.publish(name, payload);
        } else if (window.analytics && typeof window.analytics.publish === 'function') {
          window.analytics.publish(name, payload);
        }
      } catch (e) {}
    }

    /* Meta pixel — custom events, with event_id so a CAPI twin dedupes */
    if (CFG.meta !== false && typeof window.fbq === 'function') {
      try {
        var std = CFG.standardEvents && CFG.standardEvents[name];
        if (std) {
          window.fbq('track', std, payload, { eventID: payload.event_id });
        } else {
          window.fbq('trackCustom', name, payload, { eventID: payload.event_id });
        }
      } catch (e) {}
    }

    /* GA4 direct, if gtag is on the page without GTM */
    if (CFG.gtag !== false && typeof window.gtag === 'function') {
      try { window.gtag('event', name, payload); } catch (e) {}
    }

    if (CFG.debug) { try { console.log('[Dario GLP-1]', name, payload); } catch (e) {} }
  };

  /* A distinct URL per step, so session and landing-page reports in
     Shopify and any analytics tool can separate the steps. */
  DGLP.stepUrl = function (stepId) {
    if (CFG.urlSteps === false) return;
    try {
      var u = new URL(window.location.href);
      if (stepId) { u.searchParams.set('step', stepId); } else { u.searchParams.delete('step'); }
      window.history.replaceState({}, '', u.toString());
    } catch (e) {}
  };

  /* ================================================================
     2. PAGE INTERACTIONS
     ================================================================ */
  function boot() {
    /* reveal — only elements that start below the fold, so the page is
       complete at rest for a first paint, a screenshot or a no-JS view */
    if (!RM && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.remove('dglp--pre');
            e.target.classList.add('dglp--in');
            io.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
      var vh = window.innerHeight;
      $$('[data-dglp-reveal]').forEach(function (el) {
        if (el.getBoundingClientRect().top > vh * 0.92) { el.classList.add('dglp--pre'); io.observe(el); }
      });

      $$('.dglp-track').forEach(function (tr) {
        var io2 = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) { tr.classList.add('dglp--go'); io2.unobserve(e.target); } });
        }, { threshold: 0.4 });
        io2.observe(tr);
      });
    } else {
      $$('.dglp-track').forEach(function (t) { t.classList.add('dglp--go'); });
    }

    /* counters */
    function runCount(el) {
      var to = parseFloat(el.getAttribute('data-dglp-count'));
      var dec = parseInt(el.getAttribute('data-dglp-dec'), 10) || 0;
      var pre = el.getAttribute('data-dglp-prefix') || '';
      var suf = el.getAttribute('data-dglp-suffix') || '';
      if (isNaN(to)) return;
      if (RM) { el.textContent = pre + to.toFixed(dec) + suf; return; }
      var t0 = null;
      function tick(t) {
        if (!t0) t0 = t;
        var k = Math.min(1, (t - t0) / 1100), e = 1 - Math.pow(1 - k, 3);
        el.textContent = pre + (to * e).toFixed(dec) + suf;
        if (k < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }
    if ('IntersectionObserver' in window) {
      var io3 = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { runCount(e.target); io3.unobserve(e.target); } });
      }, { threshold: 0.6 });
      $$('[data-dglp-count]').forEach(function (el) { io3.observe(el); });
    } else {
      $$('[data-dglp-count]').forEach(runCount);
    }

    /* carousels */
    $$('[data-dglp-caro]').forEach(function (wrap) {
      var caro = $('.dglp-caro', wrap);
      var L = $('[data-dglp-prev]', wrap);
      var R = $('[data-dglp-next]', wrap);
      if (!caro) return;
      function step() { var c = caro.querySelector('.dglp-med'); return c ? c.getBoundingClientRect().width + 20 : 340; }
      function sync() {
        if (L) L.disabled = caro.scrollLeft < 8;
        if (R) R.disabled = caro.scrollLeft > caro.scrollWidth - caro.clientWidth - 8;
      }
      if (L) L.addEventListener('click', function () { caro.scrollBy({ left: -step() * 2, behavior: RM ? 'auto' : 'smooth' }); });
      if (R) R.addEventListener('click', function () { caro.scrollBy({ left: step() * 2, behavior: RM ? 'auto' : 'smooth' }); });
      caro.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();

      var down = false, sx = 0, sl = 0, moved = 0;
      caro.addEventListener('pointerdown', function (e) { down = true; moved = 0; sx = e.clientX; sl = caro.scrollLeft; caro.style.scrollBehavior = 'auto'; });
      window.addEventListener('pointermove', function (e) {
        if (!down) return;
        var d = e.clientX - sx; moved = Math.abs(d);
        if (moved > 4) caro.scrollLeft = sl - d;
      });
      window.addEventListener('pointerup', function () { down = false; caro.style.scrollBehavior = ''; });
      caro.addEventListener('click', function (e) { if (moved > 6) { e.preventDefault(); e.stopPropagation(); } }, true);
    });

    /* FAQ accordion */
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.dglp-faq__q');
      if (!b) return;
      var f = b.parentNode;
      var on = !f.classList.contains('dglp--open');
      f.classList.toggle('dglp--open', on);
      b.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (on) DGLP.track('faq_opened', { question: b.textContent.trim().slice(0, 80) });
    });

    /* hero parallax */
    var hero = $('[data-dglp-parallax]');
    if (hero && !RM) {
      window.addEventListener('scroll', function () {
        var y = window.pageYOffset;
        if (y < 900) hero.style.transform = 'translateY(' + (y * 0.045) + 'px)';
      }, { passive: true });
    }

    /* section-view tracking */
    if ('IntersectionObserver' in window) {
      var io4 = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) {
            DGLP.track('section_viewed', { section_name: e.target.getAttribute('data-dglp-section') });
            io4.unobserve(e.target);
          }
        });
      }, { threshold: 0.35 });
      $$('[data-dglp-section]').forEach(function (el) { io4.observe(el); });
    }

    Quiz.init();
  }

  /* ================================================================
     3. THE ASSESSMENT FUNNEL
     Every screen, label, option and price comes from the JSON the
     section renders out of its theme-editor blocks.
     ================================================================ */
  var Quiz = {
    cfg: null, ov: null, stage: null, bar: null, lab: null, pathEl: null,
    S: null, started: false, timer: null,

    init: function () {
      var node = document.getElementById('dglp-quiz-config');
      if (!node) return;
      try { this.cfg = JSON.parse(node.textContent); } catch (e) { return; }
      this.ov = document.getElementById('dglp-quiz');
      if (!this.ov) return;
      this.stage = $('.dglp-quiz__stage', this.ov);
      this.bar = $('.dglp-bar i', this.ov);
      this.lab = $('.dglp-quiz__lab', this.ov);
      this.pathEl = $('.dglp-quiz__path', this.ov);

      this.S = {
        i: 0, path: (this.cfg.paths[0] || {}).id || 'a',
        answers: {}, flags: {}, ht: this.cfg.defaultHeight || 66, wt: this.cfg.defaultWeight || 212,
        plan: this.cfg.defaultPlan || (this.cfg.plans[0] || {}).id, device: false, scale: false,
        med: 0
      };

      var self = this;
      document.addEventListener('click', function (e) {
        var t = e.target.closest && e.target.closest('[data-dglp-open]');
        if (!t) return;
        e.preventDefault();
        self.open(t.getAttribute('data-dglp-path'), t.getAttribute('data-dglp-scale'), t.getAttribute('data-dglp-source'));
      });
      $('.dglp-quiz__x', this.ov).addEventListener('click', function () { self.close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !self.ov.hidden) self.close(); });
      this.stage.addEventListener('click', function (e) { self.onClick(e); });
    },

    open: function (path, scale, source) {
      if (path) { this.S.path = path; this.S.device = path !== (this.cfg.paths[0] || {}).id; }
      if (scale) this.S.scale = true;
      this.S.i = path ? 1 : 0;
      this.ov.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      var self = this;
      requestAnimationFrame(function () { self.ov.classList.add('dglp--open'); });
      if (!this.started) {
        this.started = true;
        DGLP.track(this.cfg.events.start || 'assessment_started', { entry_point: source || 'page', path_id: this.S.path });
      }
      this.render();
    },

    close: function () {
      this.ov.classList.remove('dglp--open');
      document.documentElement.style.overflow = '';
      var self = this;
      DGLP.track(this.cfg.events.abandon || 'assessment_abandoned', { step_index: this.S.i, step_id: this.stepId() });
      DGLP.stepUrl(null);
      setTimeout(function () { self.ov.hidden = true; }, RM ? 0 : 480);
    },

    steps: function () { return this.cfg.steps; },
    step: function () { return this.cfg.steps[Math.max(0, Math.min(this.cfg.steps.length - 1, this.S.i))]; },
    stepId: function () { var s = this.step(); return s ? s.id : ''; },
    path: function () {
      var ps = this.cfg.paths, id = this.S.path;
      for (var i = 0; i < ps.length; i++) { if (ps[i].id === id) return ps[i]; }
      return ps[0] || {};
    },
    plan: function () {
      var ps = this.cfg.plans, id = this.S.plan;
      for (var i = 0; i < ps.length; i++) { if (ps[i].id === id) return ps[i]; }
      return ps[0] || {};
    },

    /* The recommendation first, then every alternative the merchant listed.
       Index 0 is the one the answers point to; the person can pick another. */
    meds: function () {
      return [this.cfg.match || {}].concat(this.cfg.alternates || []);
    },
    med: function () {
      var l = this.meds();
      return l[this.S.med] || l[0] || {};
    },
    /* The match carries an explicit price. Alternatives do not have that
       field yet, so until they do the price is read out of their detail
       line ("No needle · from $149/mo"). Falls back to blank, never to
       another medication's price. */
    medPrice: function () {
      var m = this.med();
      if (m.price) return m.price;
      var hit = String(m.detail || '').match(/\$[\d,]+(?:\.\d+)?(?:\s*\/\s*[a-z]+)?/i);
      return hit ? hit[0] : '';
    },
    bmi: function () {
      var h = Number(this.S.ht) || 66, w = Number(this.S.wt) || 212;
      return (703 * w) / (h * h);
    },
    bmiNote: function () {
      var b = this.bmi(), t = this.cfg.bmi || {};
      if (b < 27) return t.low || '';
      if (b < 30) return t.mid || '';
      return t.high || '';
    },

    go: function (n) {
      var max = this.cfg.steps.length - 1;
      this.S.i = Math.max(0, Math.min(max, n));
      this.render();
    },

    onClick: function (e) {
      var t = e.target.closest && e.target.closest('button');
      if (!t) return;
      var a = function (n) { return t.getAttribute(n); };

      if (a('data-path')) {
        this.S.path = a('data-path');
        this.S.device = this.S.path !== (this.cfg.paths[0] || {}).id;
        DGLP.track('quiz_path_selected', { path_id: this.S.path });
        return this.go(1);
      }
      if (a('data-answer') !== null) {
        var step = this.step();
        this.S.answers[step.key || step.id] = a('data-answer');
        return this.next();
      }
      if (a('data-flag') !== null) {
        /* One option can be exclusive — "None of these apply to me". Ticking it
           clears the rest; ticking anything else clears it. Repainting the
           buttons in place rather than re-rendering keeps the screen still. */
        var k = a('data-flag');
        var st = this.step();
        var opts = st.options || [];
        var ex = (st.exclusive || '').trim();
        var on = !this.S.flags[k];
        var i;

        if (ex && on && a('data-opt') === ex) {
          for (i = 0; i < opts.length; i++) delete this.S.flags['f' + i];
        } else if (ex && on) {
          for (i = 0; i < opts.length; i++) {
            if (String(opts[i]).trim() === ex) delete this.S.flags['f' + i];
          }
        }
        this.S.flags[k] = on;
        if (!on) delete this.S.flags[k];

        var sf = this.S.flags;
        $$('[data-flag]', this.stage).forEach(function (b) {
          b.classList.toggle('dglp--on', !!sf[b.getAttribute('data-flag')]);
        });
        return;
      }
      if (a('data-med') !== null) {
        this.S.med = parseInt(a('data-med'), 10) || 0;
        DGLP.track('quiz_medication_selected', {
          med_index: this.S.med, is_recommended: this.S.med === 0 ? 1 : 0
        });
        return this.render();
      }
      if (a('data-plan')) {
        this.S.plan = a('data-plan');
        if (this.plan().scaleFree) this.S.scale = true;
        DGLP.track('quiz_plan_selected', { plan_id: this.S.plan });
        return this.render();
      }
      if (a('data-add')) {
        var key = a('data-add');
        this.S[key] = !this.S[key];
        DGLP.track('quiz_addon_toggled', { addon: key, selected: this.S[key] ? 1 : 0 });
        return this.render();
      }
      if (a('data-next') !== null) return this.next();
      if (a('data-back') !== null) return this.go(this.S.i - 1);
      if (a('data-restart') !== null) { this.S.i = 0; this.started = false; return this.render(); }
      if (a('data-checkout') !== null) {
        DGLP.track(this.cfg.events.checkout || 'assessment_checkout_started', {
          plan_id: this.S.plan, path_id: this.S.path,
          addon_device: this.S.device ? 1 : 0, addon_scale: this.S.scale ? 1 : 0
        });
        var url = this.cfg.checkoutUrl;
        if (url) {
          var sep = url.indexOf('?') === -1 ? '?' : '&';
          /* An index, never a drug name — a medication in a URL is health data. */
          window.location.href = url + sep + 'sid=' + encodeURIComponent(SID) + '&plan=' + encodeURIComponent(this.S.plan) + '&track=' + encodeURIComponent(this.S.path) + '&med=' + encodeURIComponent(this.S.med);
        }
        return;
      }
    },

    next: function () {
      if (this.S.i >= this.cfg.steps.length - 1) return;
      this.go(this.S.i + 1);
    },

    render: function () {
      var s = this.step(), P = this.path(), h = '', self = this;
      var ARROW = '<svg width="16" height="12" viewBox="0 0 18 14" aria-hidden="true"><path d="M1 7h15M11 2l5 5-5 5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      var CHECK = '<svg width="16" height="16" viewBox="0 0 18 18" aria-hidden="true"><path d="M3 9.5l4 4L15 5" fill="none" stroke="#2C6B57" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      var eyebrow = s.eyebrow ? '<p class="dglp__eyebrow">' + esc(s.eyebrow) + '</p>' : '';
      /* Order-summary sub-lines: what the item actually includes, then the
         fulfilment note. Either half may be blank. */
      var joinNote = function (a, b) { return [a, b].filter(Boolean).join(' · '); };
      var back = s.back === false ? '' : '<button class="dglp-back" type="button" data-back="1">&larr; ' + esc(this.cfg.labels.back || 'Back') + '</button>';

      if (s.type === 'paths') {
        h = '<div class="dglp-q dglp-q--wide">' + eyebrow +
          '<h2>' + esc(s.heading) + '</h2>' +
          (s.sub ? '<p class="dglp-q__sub" style="max-width:66ch">' + esc(s.sub) + '</p>' : '') +
          '<div class="dglp-paths">' + this.cfg.paths.map(function (p) {
            return '<button class="dglp-path" type="button" data-path="' + esc(p.id) + '">' +
              (p.icon || '') +
              '<b>' + esc(p.title) + '</b><span>' + esc(p.body) + '</span><em>' + esc(p.cta) + ' &rarr;</em></button>';
          }).join('') + '</div></div>';

      } else if (s.type === 'single') {
        var two = (s.layout === 'two');
        h = '<div class="dglp-q">' + eyebrow + '<h2>' + esc(s.heading) + '</h2>' +
          (s.sub ? '<p class="dglp-q__sub">' + esc(s.sub) + '</p>' : '') +
          '<div class="' + (two ? 'dglp-q__opts--2' : 'dglp-q__opts') + '">' +
          (s.options || []).map(function (o) {
            return '<button class="dglp-opt" type="button" data-answer="' + esc(o) + '">' + esc(o) + '</button>';
          }).join('') + '</div>' + back + '</div>';

      } else if (s.type === 'multi') {
        h = '<div class="dglp-q" style="max-width:720px">' + eyebrow + '<h2>' + esc(s.heading) + '</h2>' +
          (s.sub ? '<p class="dglp-q__sub">' + esc(s.sub) + '</p>' : '') +
          '<div class="dglp-q__opts--2">' + (s.options || []).map(function (o, i) {
            return '<button class="dglp-opt' + (self.S.flags['f' + i] ? ' dglp--on' : '') + '" type="button" data-flag="f' + i + '" data-opt="' + esc(o) + '">' + esc(o) + '</button>';
          }).join('') + '</div>' +
          '<button class="dglp__btn" type="button" data-next="1" style="align-self:flex-start">' + esc(s.cta || 'Continue') + ARROW + '</button>' + back + '</div>';

      } else if (s.type === 'body') {
        h = '<div class="dglp-q">' + eyebrow + '<h2>' + esc(s.heading) + '</h2>' +
          '<div style="display:flex;gap:16px;flex-wrap:wrap">' +
          '<div class="dglp-fld"><label for="dglpHt">' + esc(s.heightLabel || 'Height (inches)') + '</label><input id="dglpHt" type="number" inputmode="numeric" value="' + esc(this.S.ht) + '"></div>' +
          '<div class="dglp-fld"><label for="dglpWt">' + esc(s.weightLabel || 'Weight (lbs)') + '</label><input id="dglpWt" type="number" inputmode="numeric" value="' + esc(this.S.wt) + '"></div></div>' +
          '<div class="dglp-bmi"><div><span class="dglp__k">' + esc(s.bmiLabel || 'Your BMI') + '</span><b id="dglpBmi">' + this.bmi().toFixed(1) + '</b></div><i></i><span id="dglpBmiN">' + esc(this.bmiNote()) + '</span></div>' +
          '<button class="dglp__btn" type="button" data-next="1" style="align-self:flex-start">' + esc(s.cta || 'Continue') + ARROW + '</button>' + back + '</div>';

      } else if (s.type === 'interstitial') {
        h = '<div class="dglp-q dglp-q--wide" style="align-items:center;text-align:center">' +
          (s.eyebrow ? '<p class="dglp__eyebrow" style="align-self:center">' + esc(s.eyebrow) + '</p>' : '') +
          '<h2 style="max-width:22ch;margin-inline:auto">' + esc(s.heading) + '</h2>' +
          (s.sub ? '<p class="dglp-q__sub" style="max-width:64ch;margin-inline:auto">' + esc(s.sub) + '</p>' : '') +
          '<div class="dglp-proof">' + (s.proof || []).map(function (p) {
            return '<div><b>' + esc(p.value) + '</b><span>' + esc(p.label) + '</span></div>';
          }).join('') + '</div>' +
          '<button class="dglp__btn" type="button" data-next="1">' + esc(s.cta || 'Keep going') + ARROW + '</button></div>';

      } else if (s.type === 'email') {
        h = '<div class="dglp-q" style="max-width:620px">' + eyebrow + '<h2>' + esc(s.heading) + '</h2>' +
          (s.sub ? '<p class="dglp-q__sub" style="color:var(--dglp-body)">' + esc(s.sub) + '</p>' : '') +
          '<div class="dglp-fld"><label for="dglpEm">' + esc(s.fieldLabel || 'Email address') + '</label>' +
          '<input id="dglpEm" type="email" autocomplete="email" placeholder="' + esc(s.placeholder || 'you@example.com') + '" style="font-size:17px;font-weight:400"></div>' +
          '<button class="dglp__btn" type="button" data-next="1">' + esc(s.cta || 'Show me my results') + ARROW + '</button>' +
          '<button class="dglp-back" type="button" data-next="1" style="align-self:center;text-decoration:underline">' + esc(s.skip || 'Skip') + '</button>' +
          (s.legal ? '<p style="font-size:12px;line-height:1.5;color:var(--dglp-faint);text-align:center">' + esc(s.legal) + '</p>' : '') + '</div>';

      } else if (s.type === 'loader') {
        h = '<div class="dglp-load"><svg class="dglp-spin" width="72" height="72" viewBox="0 0 72 72" aria-hidden="true"><circle cx="36" cy="36" r="30" fill="none" stroke="#E6DACA" stroke-width="6"/><path d="M36 6a30 30 0 0122.5 49.8" fill="none" stroke="var(--dglp-accent)" stroke-width="6" stroke-linecap="round"/></svg>' +
          '<h2 style="font-size:clamp(26px,3vw,34px)">' + esc(s.heading) + '</h2>' +
          '<div style="display:flex;flex-direction:column;gap:12px;width:100%">' +
          (s.ticks || []).map(function (t, i) {
            return '<div class="dglp-tick' + (i === 0 ? ' dglp--on' : '') + '" data-tick="' + i + '">' + CHECK + '<span>' + esc(t) + '</span></div>';
          }).join('') + '</div></div>';

      } else if (s.type === 'results') {
        var meds = this.meds(), pick = this.S.med;
        var m = meds[pick] || meds[0] || {};
        h = '<div class="dglp-q dglp-q--wide"><div class="dglp-res">' +
          '<div class="dglp-profile"><span class="dglp__k dglp__k--accent">' + esc(s.profileLabel || 'Your profile') + '</span><dl>' +
          '<div><dt>' + esc(s.managingLabel || 'Managing') + '</dt><dd>' + esc(P.label) + '</dd></div>' +
          /* Only answers the merchant gave a label to belong on this card.
             Without this filter an unlabelled step prints its raw step id. */
          Object.keys(this.S.answers).filter(function (k) {
            return !!(self.cfg.answerLabels && self.cfg.answerLabels[k]);
          }).map(function (k) {
            var lab = self.cfg.answerLabels[k];
            return '<div><dt>' + esc(lab) + '</dt><dd>' + esc(self.S.answers[k]) + '</dd></div>';
          }).join('') +
          '<div><dt>BMI</dt><dd>' + this.bmi().toFixed(1) + '</dd></div></dl><div class="dglp__hr"></div>' +
          '<div style="display:flex;gap:10px;align-items:flex-start"><svg width="17" height="17" viewBox="0 0 18 18" aria-hidden="true" style="flex:none;margin-top:2px"><path d="M3 9.5l4 4L15 5" fill="none" stroke="#7FD4AC" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
          '<span style="font-size:14px;line-height:1.5;color:#9BE0BE">' + esc(s.reassurance || '') + '</span></div></div>' +
          '<div style="display:flex;flex-direction:column;gap:18px"><h2 style="font-size:clamp(26px,3vw,38px)">' + esc(s.heading) + '</h2>' +
          /* The chosen medication sits in the big card; everything else stays
             below as a button, so the person can change what was suggested. */
          '<div class="dglp-match">' + (m.image ? '<img src="' + esc(m.image) + '" alt="">' : '') +
          '<div style="flex:1;display:flex;flex-direction:column;gap:5px"><span class="dglp__tag dglp__tag--new" style="align-self:flex-start">' +
          esc(pick === 0 ? (m.badge || 'Best match') : (s.chosenBadge || 'Your choice')) + '</span>' +
          '<b style="font-size:22px;font-weight:600;letter-spacing:-.02em">' + esc(m.name) + '</b>' +
          '<span style="font-size:14px;color:var(--dglp-muted)">' + esc(m.detail) + '</span></div></div>' +
          (meds.length > 1 ? '<span class="dglp__k">' + esc(s.switchLabel || 'Or ask your provider about') + '</span>' : '') +
          '<div class="dglp-alts">' + meds.map(function (alt, i) {
            if (i === pick) return '';
            return '<button class="dglp-alt" type="button" data-med="' + i + '">' +
              (alt.image ? '<img src="' + esc(alt.image) + '" alt="">' : '') +
              '<span class="dglp-alt__b"><b style="font-size:16px;font-weight:600;display:block">' + esc(alt.name) +
              (i === 0 ? ' <em class="dglp-alt__rec">' + esc(s.recNote || 'recommended') + '</em>' : '') + '</b>' +
              '<span style="font-size:13px;color:var(--dglp-muted)">' + esc(alt.detail) + '</span></span></button>';
          }).join('') + '</div>' +
          '<button class="dglp__btn" type="button" data-next="1" style="align-self:flex-start">' + esc(s.cta || 'Choose my plan') + ARROW + '</button></div></div></div>';

      } else if (s.type === 'plans') {
        var free = !!this.plan().scaleFree;
        h = '<div class="dglp-q dglp-q--wide"><h2 style="font-size:clamp(26px,3vw,36px)">' + esc(s.heading) + '</h2>' +
          (s.sub ? '<p class="dglp-q__sub">' + esc(s.sub) + '</p>' : '') +
          '<div class="dglp-plans">' + this.cfg.plans.map(function (p) {
            return '<button class="dglp-plan' + (self.S.plan === p.id ? ' dglp--on' : '') + '" type="button" data-plan="' + esc(p.id) + '">' +
              '<u>' + esc(p.term) + '</u>' +
              '<b>' + esc(p.price) + (p.was ? ' <s>' + esc(p.was) + '</s>' : '') + '</b>' +
              (p.note ? '<span class="' + (p.highlight ? 'dglp--a' : '') + '">' + esc(p.note) + '</span>' : '') +
              /* The recurring terms, kept legible next to an intro price. */
              (p.renewal ? '<em class="dglp-plan__rn' + (p.renewalStrong ? ' dglp-plan__rn--strong' : '') + '">' + esc(p.renewal) + '</em>' : '') +
              '</button>';
          }).join('') + '</div>' +
          '<span class="dglp__k">' + esc(s.addonLabel || 'Optional, yours to keep') + '</span>' +
          '<div class="dglp-adds">' +
          '<button class="dglp-add' + (this.S.device ? ' dglp--on' : '') + '" type="button" data-add="device"><i>' + (P.deviceIcon || '') + '</i>' +
          '<span class="dglp-add__t"><b>' + esc(P.deviceName) + '</b><span>' + esc(P.deviceNote) + '</span></span><u>' + esc(P.devicePrice) + '</u></button>' +
          '<button class="dglp-add' + (this.S.scale ? ' dglp--on' : '') + '" type="button" data-add="scale"><i>' + (this.cfg.scale.icon || '') + '</i>' +
          '<span class="dglp-add__t"><b>' + esc(this.cfg.scale.name) + '</b><span>' + esc(this.cfg.scale.note) + '</span></span>' +
          '<u>' + esc(free ? (this.cfg.scale.freeLabel || 'Free') : this.cfg.scale.price) + '</u></button></div>' +
          '<div class="dglp-vow"><svg width="26" height="30" viewBox="0 0 44 52" aria-hidden="true"><path d="M22 3l17 6.5v14c0 11.6-7.2 21.4-17 25.5C12.2 44.9 5 35.1 5 23.5v-14L22 3z" fill="none" stroke="#7FD4AC" stroke-width="2.6" stroke-linejoin="round"/><path d="M14.5 25l5.5 5.5L30 19.5" fill="none" stroke="#7FD4AC" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
          '<span style="flex:1"><b style="color:#fff">' + esc(s.promiseStrong || '') + '</b> <span>' + esc(s.promise || '') + '</span></span></div>' +
          '<button class="dglp__btn" type="button" data-next="1">' + esc(s.cta || 'Continue') + ARROW + '</button></div>';

      } else if (s.type === 'intake') {
        h = '<div class="dglp-intake"><div class="dglp-intake__h">' +
          (s.image ? '<img src="' + esc(s.image) + '" alt="">' : '') +
          '<div style="flex:1;min-width:220px"><u>' + esc(s.kicker || '') + '</u><b>' + esc(s.heading) + '</b></div>' +
          '<span style="display:flex;align-items:center;gap:7px;background:rgba(255,255,255,.1);border-radius:999px;padding:8px 14px;font-size:12px;font-weight:600;color:#C9DCEC">' +
          '<svg width="13" height="13" viewBox="0 0 20 20" aria-hidden="true"><rect x="3" y="8.5" width="14" height="9" rx="2" fill="none" stroke="#C9DCEC" stroke-width="1.8"/><path d="M6.5 8.5V6a3.5 3.5 0 017 0v2.5" fill="none" stroke="#C9DCEC" stroke-width="1.8" stroke-linecap="round"/></svg>' +
          esc(s.badge || 'HIPAA-protected') + '</span></div>' +
          '<div class="dglp-intake__b"><p>' + esc(s.body) + '</p>' +
          '<div class="dglp-iq">' + (s.items || []).map(function (it, i) {
            return '<div><em>' + (i + 1) + '</em>' + esc(it) + '</div>';
          }).join('') + '</div>' +
          (s.footnote ? '<div style="display:flex;gap:11px;align-items:flex-start;border-top:1px solid #E4EAEF;padding-top:16px">' +
            '<svg width="17" height="17" viewBox="0 0 20 20" aria-hidden="true" style="flex:none;margin-top:2px"><circle cx="10" cy="10" r="8" fill="none" stroke="#5E7A92" stroke-width="1.7"/><path d="M10 6.2v.6M10 9v5" fill="none" stroke="#5E7A92" stroke-width="1.9" stroke-linecap="round"/></svg>' +
            '<span style="font-size:13.5px;line-height:1.55;color:#5E7A92">' + esc(s.footnote) + '</span></div>' : '') +
          '<button class="dglp__btn" type="button" data-next="1" style="background:var(--dglp-clinical)">' + esc(s.cta || 'Start medical intake') + ARROW + '</button></div></div>';

      } else if (s.type === 'checkout') {
        var PL = this.plan(), freeS = !!PL.scaleFree;
        h = '<div class="dglp-q dglp-q--wide" style="flex-direction:row;flex-wrap:wrap;gap:28px;align-items:flex-start">' +
          '<div style="flex:1;min-width:300px;display:flex;flex-direction:column;gap:16px">' + eyebrow +
          '<h2 style="font-size:clamp(26px,3vw,38px)">' + esc(s.heading) + '</h2>' +
          '<p class="dglp-q__sub" style="color:var(--dglp-body);max-width:50ch">' + esc(s.sub || '') + '</p>' +
          '<div style="display:flex;flex-direction:column;gap:10px">' + (s.assurances || []).map(function (a) {
            return '<div style="display:flex;gap:10px;align-items:center">' + CHECK + '<span style="font-size:14.5px">' + esc(a) + '</span></div>';
          }).join('') + '</div>' +
          (s.security ? '<span style="font-size:12.5px;color:var(--dglp-muted)">' + esc(s.security) + '</span>' : '') + '</div>' +
          '<div class="dglp-summary"><span class="dglp__k">' + esc(s.orderLabel || 'Your order') + '</span>' +
          '<div class="dglp-line"><div><b>' + esc(s.membershipLabel || 'Membership') + '</b><span>' + esc(PL.summary || PL.term) + '</span></div><u>' + esc(PL.total || '') + '</u></div>' +
          '<div class="dglp-line"><div><b>' + esc(this.med().name || '') + '</b><span>' + esc(s.medicationNote || '') + '</span></div><u>' + esc(this.medPrice()) + '</u></div>' +
          '<div class="dglp-line"><div><b>' + esc(P.deviceName) + '</b><span>' + esc(this.S.device ? joinNote(P.deviceNote, s.addedNote) : (s.notAddedNote || 'Not added')) + '</span></div><u>' + esc(this.S.device ? P.devicePrice : '—') + '</u></div>' +
          '<div class="dglp-line"><div><b>' + esc(this.cfg.scale.name) + '</b><span>' + esc(this.S.scale ? joinNote(this.cfg.scale.note, freeS ? (this.cfg.scale.freeNote || 'Included') : s.addedNote) : (s.notAddedNote || 'Not added')) + '</span></div>' +
          '<u>' + esc(this.S.scale ? (freeS ? (this.cfg.scale.freeLabel || 'Free') : this.cfg.scale.price) : '—') + '</u></div>' +
          '<div class="dglp__hr" style="background:var(--dglp-line)"></div>' +
          '<div class="dglp-due"><b>' + esc(s.dueLabel || 'Due today') + '</b><u>' + esc(s.dueValue || '$0.00') + '</u></div>' +
          '<span style="font-size:12.5px;line-height:1.5;color:var(--dglp-muted)">' + esc(s.afterNote || '').replace('{plan}', esc(PL.after || '')) + '</span>' +
          '<button class="dglp__btn" type="button" data-checkout="1">' + esc(s.cta || 'Complete secure checkout') + '</button>' +
          '<button class="dglp-back" type="button" data-restart="1" style="align-self:center;text-decoration:underline">' + esc(s.restart || 'Start over') + '</button></div></div>';
      }

      this.stage.innerHTML = h;
      var first = this.stage.firstElementChild;
      if (first && !RM) {
        first.style.opacity = '0';
        first.style.transform = 'translateY(16px)';
        requestAnimationFrame(function () {
          first.style.transition = 'opacity .45s var(--dglp-ease), transform .45s var(--dglp-ease)';
          first.style.opacity = '1';
          first.style.transform = 'none';
        });
      }
      this.stage.scrollTop = 0;

      var pct = s.progress != null ? s.progress : Math.round((this.S.i / (this.cfg.steps.length - 1)) * 100);
      if (this.bar) this.bar.style.width = pct + '%';
      if (this.lab) this.lab.textContent = s.label || '';
      if (this.pathEl) this.pathEl.textContent = P.label || '';

      /* live BMI */
      if (s.type === 'body') {
        var hI = document.getElementById('dglpHt'), wI = document.getElementById('dglpWt');
        var upd = function () {
          self.S.ht = hI.value; self.S.wt = wI.value;
          document.getElementById('dglpBmi').textContent = self.bmi().toFixed(1);
          document.getElementById('dglpBmiN').textContent = self.bmiNote();
        };
        hI.addEventListener('input', upd);
        wI.addEventListener('input', upd);
      }

      /* loader auto-advance */
      clearTimeout(this.timer);
      if (s.type === 'loader') {
        var ticks = $$('.dglp-tick', this.stage);
        ticks.forEach(function (el, i) {
          if (i === 0) return;
          setTimeout(function () { el.classList.add('dglp--on'); }, 500 + i * 650);
        });
        this.timer = setTimeout(function () {
          if (self.step() === s) self.next();
        }, (s.duration || 2400));
      }

      /* tracking — one event per step, generic parameters only */
      DGLP.stepUrl(s.id);
      DGLP.track(this.cfg.events.step || 'quiz_step_viewed', {
        step_index: this.S.i,
        step_id: s.id,
        step_name: s.label || s.id,
        step_total: this.cfg.steps.length,
        path_id: this.S.path
      });
      if (s.id && this.cfg.events.perStepPrefix) {
        DGLP.track(this.cfg.events.perStepPrefix + s.id, { step_index: this.S.i, path_id: this.S.path });
      }
      if (this.S.i === this.cfg.steps.length - 1) {
        DGLP.track(this.cfg.events.complete || 'assessment_completed', {
          plan_id: this.S.plan, path_id: this.S.path
        });
      }
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* the theme editor re-renders sections without a page reload */
  document.addEventListener('shopify:section:load', function () {
    window.__dglpBooted = false;
    setTimeout(function () { if (!window.__dglpBooted) { window.__dglpBooted = true; boot(); } }, 0);
  });
})();
